export default "__VITE_ASSET__CyOrWZ_4__"